import { NAVBAR_PATHS } from './navbar.paths';

export const HeaderConstants = Object.freeze({
    /** Header bell unread-count refresh cadence. */
    UNREAD_POLL_INTERVAL_MS: 60000,
    /** Counts above this render as "99+". */
    UNREAD_BADGE_MAX: 99,
    /** How many notifications the bell menu summarizes. */
    NOTIFICATIONS_MENU_SIZE: 5,
    /** Figma «Navbar» account popover width (797:54166). */
    ACCOUNT_MENU_WIDTH: 240,
});

/**
 * Pages reached from the header rather than the sidebar (Figma «Navbar»
 * 797:54130), so the breadcrumb can still name them.
 */
export const HEADER_PAGES = Object.freeze([
    { path: NAVBAR_PATHS.notifications, label: 'Notifications' },
    { path: NAVBAR_PATHS.support, label: 'Support' },
]);

export default HeaderConstants;
